import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { SectionHeader } from "@pentabd/ui";

import {
  InputDateControllerRow,
  InputTextRow,
  SelectControllerRow,
} from "@components";

import {
  FILE_INQUIRY,
  FileInquiryFormDataType,
} from "@validations/HRM/employee/fileInquiryValidation";

type FileInquiryPropsType = {
  isEditMode?: boolean;
};

export const FileInquiryForm = ({ isEditMode }: FileInquiryPropsType) => {
  const { t } = useTranslation();

  const {
    control,
    register,
    setValue,
    formState: { errors },
  } = useFormContext<FileInquiryFormDataType>();

  return (
    <div className="d-flex flex-column gap-8">
      <SectionHeader title={t("EMPLOYEE.FILE_INQUIRY.FORM.LABEL")} />
      <SelectControllerRow
        register={{ ...register(FILE_INQUIRY.FILE_TYPE) }}
        control={control}
        setValue={setValue}
        name={FILE_INQUIRY.FILE_TYPE}
        options={[
          {
            label: "Investigation",
            value: "INVESTIGATION",
          },
          {
            label: "Enquiry",
            value: "ENQUIRY",
          },
        ]}
        label="EMPLOYEE.FILE_INQUIRY.FORM.FILE_TYPE"
        error={errors}
        required
        disabled={isEditMode} // Disable if in edit mode
      />
      <InputTextRow
        register={{ ...register(FILE_INQUIRY.SUBJECT) }}
        label="EMPLOYEE.FILE_INQUIRY.FORM.SUBJECT"
        error={errors}
        required
        disabled={isEditMode} // Disable if in edit mode
      />
      <InputDateControllerRow
        label="EMPLOYEE.FILE_INQUIRY.FORM.FILE_FROM_DATE"
        control={control}
        register={{ ...register(FILE_INQUIRY.FILE_FROM_DATE) }}
        errors={errors}
        name={FILE_INQUIRY.FILE_FROM_DATE}
        required
        disabled={isEditMode} // Disable if in edit mode
      />

      <SelectControllerRow
        register={{ ...register(FILE_INQUIRY.STATUS) }}
        control={control}
        setValue={setValue}
        name={FILE_INQUIRY.STATUS}
        options={[
          {
            label: "Assigned",
            value: "ASSIGNED",
          },
          {
            label: "In Progress",
            value: "IN_PROGRESS",
          },
          {
            label: "Completed",
            value: "COMPLETED",
          },
        ]}
        label="EMPLOYEE.FILE_INQUIRY.FORM.STATUS"
        error={errors}
        // required
      />
      <InputTextRow
        register={{ ...register(FILE_INQUIRY.PERFORMANCE_EVALUATION) }}
        label="EMPLOYEE.FILE_INQUIRY.FORM.PERFORMANCE_EVALUATION"
        error={errors}
        type="number"
      />
      <InputTextRow
        register={{ ...register(FILE_INQUIRY.UNIQUE_NAME) }}
        label="EMPLOYEE.FILE_INQUIRY.FORM.UNIQUE_NAME"
        error={errors}
        required
        disabled={isEditMode} // Disable if in edit mode
      />
    </div>
  );
};
